const contactEmail = "coloryouapp@gmail.com";
const year = "2025";
const es = "coloryou06-21";

const constants = {
  year,
  contactEmail,
  es,
};

export default constants;
